/** User-facing labels for LP banner copy fields (add/edit asset forms). */
export const LP_BANNER_COPY_FIELD_LABELS = {
  bannerTitle: 'First line',
  bannerTitleAccent: 'Second line',
  bannerSubtitle: 'Third line',
  /** Maps to asset `additionalText` — v4 subtitle under titles (before fine-print). */
  additionalText: 'Fourth line',
  bannerDisclaimer: 'Badge'
} as const
